import { useQuery } from '@apollo/client';
// Types
import { GetFeaturedStreams } from 'api/homePage/types/GetFeaturedStreams';
// API
import { GET_FEATURED_STREAMS } from 'api/homePage/queries';

export const useGetFeaturedStreams = () => {
  return useQuery<GetFeaturedStreams>(GET_FEATURED_STREAMS, {
    fetchPolicy: 'cache-first',
  });
};
